import React, {Component} from 'react'
import Input from '../../components/UI/Input/Input';
import './Footer.css';
import Button from '../../components/UI/Button/Button';
import Axios from 'axios';
import Loader from '../../components/UI/Loader/Loader';
import facebook from './Assets/facebook.png'
import twitter from './Assets/twitter.png'
import instagram from './Assets/instagram.png'
import Notification from '../UI/Notification/Notification';


const emailInput = {
    elemType: "input",
    config: {
        type: 'text', 
        placeholder: "Email"
    },
    value:"",
    validation: function(){
        let valid = false;
        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if(emailRegex.test(this.value)){
            valid = true
        }
        return valid
    },
    isValid: false,
    errorMessage: "Please input a valid email address",
    touched: false, 
}


class Footer extends Component{
    state = {
        loading:false,
        isFormValid: true,
        isSubmitted: false,
        emailInput: emailInput, 
        notification: {
            show:false,
            data: {
                status: 'primary'
            }
        },
    }
    emailValidationHandler =(event)=> {
        const UpdatedFormElement = {...this.state.emailInput}
        UpdatedFormElement.value = event.target.value;
        UpdatedFormElement.touched = true;
        this.setState({emailInput: UpdatedFormElement});
    }
    refreshNotification = () => {
        this.setState(state => {
            return{
                ...state, 
                notification: {
                    ...state.notification, 
                    show:false
                }
            }
        })
    }
     submitEmail = async (e)=>{
        e.preventDefault();
        let isValid = this.state.emailInput.validation()
        const emailInput1 = {...this.state.emailInput, touched:true}
        await this.setState({isFormValid: isValid, isSubmitted: true, emailInput: emailInput1});
        if(this.state.isFormValid && this.state.isSubmitted){
            this.setState({loading:true})
            let data ={email: this.state.emailInput.value}
            Axios.post('https://blossomandflourish-backend.herokuapp.com/api/subscribe/add', data)
            .then(data => {
                this.setState({
                    emailInput,
                    loading:false, 
                    notification: {
                        show: true, 
                        data: {
                            status: 'success', 
                            content: "You have successfully subscribed to our news letter"
                        }
                    }
                })
            }).catch(err => {
                this.setState({emailInput, loading:false})
                if(err.response && err.response.data){
                    this.setState({
                        emailInput,
                        loading:false, 
                        notification: {
                            show: true, 
                            data: {
                                status: 'error', 
                                content: err.response.data.message
                            }
                        }
                    })
                }
            })
        }

    }
    render(){
       let toShow = <Button name="Subscribe" clicked={(e)=>this.submitEmail(e)} big/>
       if(this.state.loading){
           toShow = <div className="Footer_Loader">
               <Loader />
            </div>
       }
        return(
            <div className="Footer">
                <Notification
                show={this.state.notification.show}
                data={this.state.notification.data}
                refresh={this.refreshNotification}
                />
                <p className="Footer_Sub">SUBSCRIBE TO NEWSLETTER</p>
                <div className="deForm">
                    <form>
                        <div className="FormInput">
                            <Input 
                            elemType={this.state.emailInput.elemType} 
                            config={this.state.emailInput.config}
                            errorMessage={this.state.emailInput.errorMessage}
                            valid={this.state.isFormValid}
                            touched={this.state.emailInput.touched}
                            value={this.state.emailInput.value}
                            changed={(event)=>this.emailValidationHandler(event)}/>
                            <div className="Footer_SubBtn">
                                {toShow}
                            </div>
                        </div>
                    </form>
                </div>
                <div className="Footer_Contacts">
                    <div className="Specific_Contact">
                        <p><ion-icon name="location-outline"></ion-icon></p>
                        <p>23 Umuchu Street Idaw River Layout</p>
                        <p> Enugu State, Nigeria.</p>
                    </div>
                    <div className="Specific_Contact">
                        <p><ion-icon name="call-outline"></ion-icon></p>
                        <p><a href="callto:+2347068670455">+234 706 867 0455</a></p>
                        <p> <a href="callto:+2349065047000">+234 906 504 7000</a></p>
                    </div>
                    <div className="Specific_Contact">
                        <p><ion-icon name="mail-outline"></ion-icon></p>
                        <p> <a href="mailto:blossomnflourish2020@gmail.com">blossomnflourish2020@gmail.com</a> </p>
                    </div>
                </div>
                <div className="Footer_Last">
                    <p className="Footer_Connect">Connect on social media</p>
                    <p className="Footer_Socials">
                        <a href="#" ><img src={facebook} alt="facebook" /></a>
                        <a href="#" ><img src={instagram} alt="instagram" /></a>
                        <a href="#" ><img src={twitter} alt="twitter" /></a>
                    </p>
                </div>
            </div>
        )
    }
}

export default Footer